import React, { useState, useReducer } from "react";
import Header from "./Header";
import BookingForm from "./BookingForm";
import Progress from "./Progress";
import Nav from "./Nav";
import { fetchAPI, submitAPI } from "../api/api";

const BookingPage = () => {
  const [date, setDate] = useState(new Date());
  const [pageNum, setPageNum] = useState(1);

  function initializeTimes(date) {
    return fetchAPI(date);
  }

  function updateTimes(date) {
    const dateObj = new Date(date);
    return fetchAPI(dateObj);
  }

  const resOccasionList = [
    "None",
    "Birthday",
    "Anniversary",
    "Work Party",
    "Happy Hour",
    "Divorce",
  ];

  function submitForm(formData) {
    const isSubmitted = submitAPI(formData);

    if (isSubmitted) {
      setPageNum(3);
    }
  }

  function reducer(state, action) {
    let newState;
    switch (action.type) {
      case "UPDATE_TIMES":
        const newDate = new Date(action.payload);
        newState = updateTimes(newDate);
        break;

      default:
        throw new Error();
    }
    return newState;
  }

  const [availableTimes, dispatch] = useReducer(reducer, initializeTimes(date));
  return (
    <div class="mb-20 bg-lemonyellow p-10">
      <Header>
        <Nav />
      </Header>
      <Progress pageNum={pageNum} />
      <BookingForm
        availableTimes={availableTimes}
        dispatch={dispatch}
        submitForm={submitForm}
        resOccasionList={resOccasionList}
        pageNum={pageNum}
        setPageNum={setPageNum}
      />
    </div>
  );
};

export default BookingPage;
